import { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { PdfViewerDialog } from './PdfViewerDialog';

interface ViewDocumentLinkProps {
  fileUrl?: string | null;
  pdfUrl?: string | null;
  policyId?: string;
  title?: string;
}

export function ViewDocumentLink({ fileUrl, pdfUrl, policyId, title }: ViewDocumentLinkProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setDialogOpen(true)}
        className="inline-flex items-center gap-1 rounded-md border border-[hsl(180,50%,40%)] bg-transparent px-3 py-1 text-xs font-medium text-[hsl(180,50%,40%)] transition-colors hover:bg-[hsl(180,50%,40%)] hover:text-white"
      >
        View
        <ExternalLink className="h-3 w-3" />
      </button>

      <PdfViewerDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        fileUrl={fileUrl || ''}
        pdfUrl={pdfUrl}
        policyId={policyId}
        title={title}
      />
    </>
  );
}
